<template>
	<Page class="dark-primary">
		<template v-slot:content>
			<SafeAreaTop :show-close="false">
				<div class="container mt-5vh">
					<div class="page-image">
						<img src="@/assets/survey/cutlery.svg" alt="" />
					</div>
					<Title class="centered">
						There’s often a connection between eating to satisfy emotions and gaining or losing weight
					</Title>
					<Subtitle class="centered">
						<p>
							Emotional eating can make it difficult for you to lose weight, but it is easier to deal with when you are
							aware of it and understand how it affects you.
						</p>
						<p>Would you like information on emotional eating included in your plan?</p>
					</Subtitle>
				</div>
			</SafeAreaTop>
		</template>

		<template v-slot:footer>
			<div class="container">
				<a class="btn btn-primary btn-block btn-compact" href="" @click.prevent="handleAccept"> Yes </a>
				<a class="btn btn-primary btn-block btn-compact mt-1rem" href="" @click.prevent="handleReject"> No </a>
			</div>
		</template>
	</Page>
</template>

<script setup>
import Page from '@/components/Page'
import SafeAreaTop from '@/components/SafeAreaTop'
import Title from '@/components/survey/Title.vue'
import Subtitle from '@/components/survey/Subtitle.vue'
import { inject, onMounted } from '@vue/runtime-core'
import { useRouter } from 'vue-router'
import useApi from '@/composition/api.js'

const amplitude = inject('amplitude')
const router = useRouter()
const api = useApi()

function logEvent(action) {
	amplitude.logEvent('OnboardingEmotionalEatingCourseIntroScreenDone', {
		data: action
	})
}

function handleAccept() {
	logEvent('add')
	router.push({ name: 'emotional-course' })
}

function handleReject() {
	logEvent('do_not_add')
	api.close()
}

onMounted(() =>
	amplitude.logEvent('ScreenView', {
		title: 'OnboardingEmotionalEatingCourseIntroScreen'
	})
)
</script>

<style>
.page-image {
	text-align: center;
}
</style>
